import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getWishList } from '../../api/login'
import { cartCount } from '@/api/cart'
import { alarmCount } from '@/api/alarm'

const user = {
  state: {
    token: getToken(),
    userId: '', // ums_member.id
    loginId: '', //ums_member.userId
    username: '', // username
    deposit: 0,
    point: 0,
    type: '',
    email: '',
    mobile: '',
    memberLevelInfo: {}, // 회원 등급 정보
    memberDetail: {}, // 회원 상세 정보
    cartCount: 0, // 장바구니 카운트
    alarmCount: 0, // 긴급알림 카운트
    wishList: {} // 관심 상품 목록 //TODO 새로고침할때마다 또 리스트 없어짐,,,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_LOGINID: (state, userId) => {
      state.loginId = userId
    },
    SET_DEPOSIT: (state, deposit) => {
      state.deposit = deposit
    },
    SET_POINT: (state, point) => {
      state.point = point
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile
    },
    SET_USERTYPE: (state, type) => {
      state.type = type
    },
    SET_MEMBERLEVELINFO: (state, memberLevelInfo) => {
      state.memberLevelInfo = memberLevelInfo
    },
    SET_MEMBERDETAIL: (state, memberDetail) => {
      state.memberDetail = memberDetail
    },
    SET_CARTCOUNT: (state, cartCount) => {
      state.cartCount = cartCount
    },
    SET_ALARMCOUNT: (state, alarmCount) => {
      state.alarmCount = alarmCount
    },
    SET_WISHLIST: (state, wishList) => {
      state.wishList = wishList
    }
  },
  actions: {
    // 로그인
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then(response => {
            const { data } = response
            const tokenStr = data.tokenHead + data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 사용자정보 가져오기
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(response => {
            const { data } = response
            commit('SET_USERID', data.id)
            commit('SET_LOGINID', data.userId)
            commit('SET_DEPOSIT', data.deposit)
            commit('SET_POINT', data.point)
            commit('SET_USERNAME', data.username)
            commit('SET_EMAIL', data.email)
            commit('SET_MOBILE', data.mobile)
            commit('SET_USERTYPE', data.type)
            commit('SET_MEMBERLEVELINFO', data.memberLevelInfo)
            commit('SET_MEMBERDETAIL', data.memberDetail)
            commit('SET_CARTCOUNT', data.cartCount)
            commit('SET_ALARMCOUNT', data.alarmCount)
            getWishList(data.id).then(innerResponse => {
              commit('SET_WISHLIST', innerResponse.data)
            })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
        //TDOD getWishList
      })
    },
    // 장바구니 카운트 가져오기
    GetCartCount({ commit, state }) {
      return new Promise((resolve, reject) => {
        cartCount().then(res => {
          commit('SET_CARTCOUNT', res.data)
        })
      })
    },
    // 긴급알림 카운트 가져오기
    GetAlarmCount({ commit, state }) {
      return new Promise((resolve, reject) => {
        alarmCount().then(res => {
          commit('SET_ALARMCOUNT', res.data)
        })
      })
    },

    // 로그아웃
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_USERID', '')
            commit('SET_LOGINID', '')
            commit('SET_DEPOSIT', 0)
            commit('SET_POINT', 0)
            commit('SET_USERNAME', '')
            commit('SET_EMAIL', '')
            commit('SET_MOBILE', '')
            commit('SET_USERTYPE', '')
            commit('SET_MEMBERLEVELINFO', '')
            commit('SET_MEMBERDETAIL', '')
            commit('SET_CARTCOUNT', 0)
            commit('SET_ALARMCOUNT', 0)
            commit('SET_WISHLIST', '')
            removeToken()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 프런트엔드 로그아웃
    FedLogOut({ commit }, userInfo) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USERID', '')
        commit('SET_LOGINID', '')
        commit('SET_DEPOSIT', 0)
        commit('SET_POINT', 0)
        commit('SET_USERNAME', '')
        commit('SET_EMAIL', '')
        commit('SET_MOBILE', '')
        commit('SET_USERTYPE', '')
        commit('SET_MEMBERLEVELINFO', '')
        commit('SET_MEMBERDETAIL', '')
        commit('SET_CARTCOUNT', 0)
        commit('SET_ALARMCOUNT', 0)
        commit('SET_WISHLIST', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js